import { render, staticRenderFns } from "./hidden-products-list.component.vue?vue&type=template&id=0902f0e6&scoped=true"
import script from "./hidden-products-list.component.vue?vue&type=script&lang=ts"
export * from "./hidden-products-list.component.vue?vue&type=script&lang=ts"
import style0 from "./hidden-products-list.component.vue?vue&type=style&index=0&id=0902f0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0902f0e6",
  null
  
)

export default component.exports